// Leaf predicate shared by desktop viewers without importing file navigation,
// stores, Expo native modules or editor containers.
export const isEditableDocumentFile = file => {
  if (!file) return false;
  const mime = (file.mimeType || file.type || '').toLowerCase();
  const extension = (file.extension || '').toLowerCase();
  return mime === 'application/vnd.gab-ai.document+json'
    || extension === '.gabdoc' || extension === 'gabdoc'
    || file.parameters?.documentKind === 'editable-document';
};
